import { ICreateWebsitesDataDTO, WebsitesStatus } from '@/models/websites.model';
import { TWebsiteFormValues, WebsiteFieldsNames } from '../helpers';

export class CreateWebsiteDTO implements ICreateWebsitesDataDTO {
  channelId: number;

  showcaseChannelId: number;

  title: string;

  description: string;

  imageTitle?: string;

  position?: number;

  status?: WebsitesStatus;

  image?: string;

  constructor(values: TWebsiteFormValues, showcaseChannelId: number) {
    this.showcaseChannelId = showcaseChannelId;
    this.channelId = values[WebsiteFieldsNames.CHANNEL];
    this.title = values[WebsiteFieldsNames.TITLE];
    this.description = values[WebsiteFieldsNames.DESCRIPTION];
    this.imageTitle = values[WebsiteFieldsNames.IMAGE_TITLE];
    if (values[WebsiteFieldsNames.POSITION]) {
      this.position = values[WebsiteFieldsNames.POSITION];
    }
    this.status = values[WebsiteFieldsNames.STATUS];
    this.image = values[WebsiteFieldsNames.IMAGE];
  }
}
